import React, { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useCmpInit } from '../hooks/useCmpInit';
import { useGAMInit } from '../hooks/useGAMInit';
const ConsentManagementInit = ()=>{
    const { adsEnabled  } = useContext(SessionContext);
    const isGoogleAds = useFlag('ads_da');
    useCmpInit({
        adsEnabled: adsEnabled && !isGoogleAds
    });
    useGAMInit({
        adsEnabled: adsEnabled && isGoogleAds
    });
    return null;
};
ConsentManagementInit.displayName = 'ConsentManagementInit';
export default ConsentManagementInit;
